import React, { useState } from 'react';
import paymentBanksService from '../../services/paymentBank';
import loaderIcon from '../../assets/loader.svg';
import PrimaryButton from '../../components/Layout/PrimaryButton';
import editIcon from '../../assets/edit-icon.png';

import ModalPaymentBanks from '../../components/ModalPaymentBanks';

import './PaymentBanks.scss';

const PaymentBanks = () => {
  const initialFields = {
    name: { value: '', valid: true, validationMessage: '' },
    isActive: { value: true, valid: true, validationMessage: '' },
    comments: { value: '', valid: true, validationMessage: '' },
    paymentType: { value: 'B', valid: true, validationMessage: '' },
  };

  const [fields, setFields] = useState({ ...initialFields });
  const [loader, setLoader] = useState(false);
  const [backendError, setBackendError] = useState('');
  const [successForm, setSuccessForm] = useState(false);
  const [paymentBanksList, setPaymentBanksList] = useState(false);
  const [editPaymentBank, setEditPaymentBank] = useState(false);

  const handleInputChange = (e) => {
    console.log(e);
    const target = e.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    setFields((prevFields) => ({
      ...prevFields,
      [name]: {
        ...prevFields[name],
        value: value,
      },
    }));
  };

  const savePaymentBank = async (paymentBankData) => {
    try {
      if (!editPaymentBank) {
        await paymentBanksService.createPaymentBank(paymentBankData);
      } else {
        await paymentBanksService.updatePaymentBank(paymentBankData.paymentBankID, paymentBankData);
      }
      setSuccessForm(true);
      setBackendError('');
    } catch (error) {
      console.error('Error fetching expenses:', error);
      setBackendError('Algo deu errado! Tente novamente.');
    } finally {
      setLoader(false);
    }
  };

  const handleCloseModal = (e) => {
    setPaymentBanksList(false);
  }

  const handlePaymentBankChange = async (data) => {
    console.log(data)
    setFields((prevFields) => ({
      comments: {
        ...prevFields['comments'],
        value: data.comments,
      },
      name: {
        ...prevFields['name'],
        value: data.name,
      },
      paymentBankID: {
        ...prevFields['paymentBankID'],
        value: data.paymentBankID,
      },
      isActive: {
        ...prevFields['isActive'],
        value: !data.isActive ? false : true,
      },
      paymentType: {
        ...prevFields['paymentType'],
        value: data.paymentType,
      }
    }));
    setPaymentBanksList(false);
    setEditPaymentBank(true);
  }

  const validatePaymentBankName = (name) => {
    return name.trim() !== '';
  };

  const validateForm = () => {
    // Validation for Razão Social and CNPJ
    const isNameValid = validatePaymentBankName(fields.name.value);

    setFields((prevFields) => ({
      ...prevFields,
      ['name']: {
        ...prevFields['name'],
        valid: fields.name.value.length > 2,
      },
    }));

    if (!isNameValid) {
      setLoader(false);
      return false;
    } else {
      setBackendError('');
    }

    return true;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setLoader(true);
    const formData = {};
    Object.entries(fields).forEach(([fieldName, fieldData]) => {
      formData[fieldName] = fieldData.value;
    });

    try {
      await savePaymentBank(formData);
      setSuccessForm(true);
    } catch (error) {
      console.error('Error saving companie:', error);
      setBackendError('Algo deu errado! Tente novamente.');
    } finally {
      setLoader(false);
    }
  };

  const resetForm = () => {
    setFields({ ...initialFields });
    setLoader(false);
    setBackendError('');
    setSuccessForm(false);
    setEditPaymentBank(false);
  };

  return (
    <>
      {paymentBanksList && (
        <ModalPaymentBanks onCloseModal={handleCloseModal} paymentBankData={handlePaymentBankChange} />
      )}

      <div className='paymentBanks-screen wrapper-content form-box'>
        {!backendError && !successForm && (
          <>
            {editPaymentBank && (
              <button className="back-button" onClick={(e) => { e.preventDefault(); setLoader(true); window.location.reload(); }} style={{ background: 'none', border: 'none', cursor: 'pointer', position: 'absolute', left: 10, top: 15 }}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
            )}
            <h2>{!editPaymentBank ? 'Cadastro de Formas de Pagamento/Banco' : 'Editar Formas de Pagamento/Banco'}</h2>
            <button className='editSup' onClick={() => setPaymentBanksList(true)}><img src={editIcon} alt="Edit icon" style={{ width: '18px', height: '18px' }} /></button>
          </>
        )}

        {backendError && (
          <>
            <h2 className="error-message">
              {backendError}
            </h2>
            <PrimaryButton fullWidth onClick={resetForm}>
              Voltar
            </PrimaryButton>
          </>
        )}

        {!backendError && successForm && (
          <div style={{ width: '60%', margin: '0 auto' }}>
            <h2>{!editPaymentBank ? 'Cadastro realizado no sistema!' : 'Edição realizada com sucesso!'}</h2>
            <PrimaryButton fullWidth onClick={resetForm}>
              Voltar
            </PrimaryButton>
          </div>
        )}

        {loader && !backendError && !successForm ? (
          <img src={loaderIcon} alt="Carregando..." width={100} height={100} />
        ) : (
          !successForm && (
            <form onSubmit={handleSubmit} className="paymentBanks-screen__form" action="#">
              <label>
                Nome<sup>*</sup>
                <input
                  type="text"
                  name='name'
                  className={fields.name.valid === false ? 'has-error' : ''}
                  onChange={handleInputChange}
                  defaultValue={fields.name.value}
                  tabIndex={1}
                  onBlur={(e) => {
                    validateForm();
                  }}
                />
              </label>
              
              <label>
                Ativo<sup></sup>
                <input
                  align="left"
                  type="checkbox"
                  name="isActive"
                  checked={fields.isActive.value}
                  onChange={handleInputChange}
                  tabIndex={2}
                />
              </label>
              <label>
                <div >
                  <div className='wrapper-labels' style={{display: 'inline-flex', position: 'static'}}>
                    <label style={{textAlign: 'left', marginTop: 15}}>Tipo:</label>
                    <label className='label-radio'>
                      <input type="radio" name="paymentType" value="B" 
                        checked={fields.paymentType.value === 'B'}
                        onChange={handleInputChange} />
                      &nbsp;Banco
                    </label>
                    &nbsp;&nbsp;
                    <label className='label-radio'>
                      <input type="radio" name="paymentType" value="D" 
                        checked={fields.paymentType.value === 'D'}
                        onChange={handleInputChange} />
                      &nbsp;Dinheiro
                    </label>
                  </div>
                </div>
              </label>
              <label style={{width:'100%'}}>
                Observação
                <textarea
                  name='comments'
                  onChange={handleInputChange}
                  defaultValue={fields.comments.value}
                  tabIndex={6}
                />
              </label>
              <input className={'btn--primary'} type='submit' value={!editPaymentBank ? "Salvar" : "Salvar Edição"} tabIndex={7} />
            </form>
          )
        )}
      </div>
    </>
  );
};

export default PaymentBanks;
